export default __webpack_public_path__ + "static/media/icon-001.fcb55cfd.png";